import React from "react";
import { Box, Typography } from "@mui/material";

/** Dimensiones plantilla A4 horizontal */
export const TEMPLATE_WIDTH = 3508;
export const TEMPLATE_HEIGHT = 2480;

/*
Layout real de la plantilla

marca
-------------------------------------------------

| FRONT | BACK | DETAIL1 |
|       |      |         |
|       |      |---------|
|       |      | DETAIL2 |

*/

/** regiones en fracciones 0-1 */
export const config = {
  width: TEMPLATE_WIDTH,
  height: TEMPLATE_HEIGHT,

  regions: [
    /** modelo frontal */
    {
      id: "front",
      x: 0.05,
      y: 0.15,
      width: 0.35,
      height: 0.7,
    },

    /** modelo trasero */
    {
      id: "back",
      x: 0.42,
      y: 0.15,
      width: 0.35,
      height: 0.7,
    },

    /** detalle 1 */
    {
      id: "detail1",
      x: 0.8,
      y: 0.15,
      width: 0.15,
      height: 0.33,
    },

    /** detalle 2 */
    {
      id: "detail2",
      x: 0.8,
      y: 0.52,
      width: 0.15,
      height: 0.33,
    },
  ],

  textFields: [
    {
      id: "marca",
      x: 0.05,
      y: 0.03,
      width: 0.35,
      height: 0.06,
      fontSize: 56,
      fontWeight: "bold",
      color: "#ffffff",
      padding: "5px 10px",
      backgroundColor: "grey.800",
    },
  ],
};

/** Preview de la plantilla */
function Plantilla1Preview({ marca = "MARCA", className }) {
  return (
    <Box
      className={className}
      sx={{
        width: "100%",
        height: "100%",
        minHeight: 72,
        aspectRatio: `${TEMPLATE_WIDTH}/${TEMPLATE_HEIGHT}`,
        bgcolor: "#fff",
        border: "1px solid",
        borderColor: "divider",
        borderRadius: 0.5,
        overflow: "hidden",
        position: "relative",
      }}
    >
      {/* Marca */}
      <Box
        sx={{
          position: "absolute",
          left: "5%",
          top: "3%",
          width: "35%",
          height: "6%",
          bgcolor: "grey.800",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Typography
          variant="caption"
          sx={{
            color: "white",
            fontWeight: "bold",
            fontSize: ".25rem",
          }}
        >
          {marca}
        </Typography>
      </Box>

      {/* FRONT */}
      <Box
        sx={{
          position: "absolute",
          left: "5%",
          top: "15%",
          width: "35%",
          height: "70%",
          border: "1px dashed",
          borderColor: "grey.400",
          bgcolor: "grey.100",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Typography variant="caption">FRONT</Typography>
      </Box>

      {/* BACK */}
      <Box
        sx={{
          position: "absolute",
          left: "42%",
          top: "15%",
          width: "35%",
          height: "70%",
          border: "1px dashed",
          borderColor: "grey.400",
          bgcolor: "grey.100",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Typography variant="caption">BACK</Typography>
      </Box>

      {/* DETAIL 1 */}
      <Box
        sx={{
          position: "absolute",
          left: "80%",
          top: "15%",
          width: "15%",
          height: "33%",
          border: "1px dashed",
          borderColor: "grey.400",
          bgcolor: "grey.100",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Typography variant="caption">D1</Typography>
      </Box>

      {/* DETAIL 2 */}
      <Box
        sx={{
          position: "absolute",
          left: "80%",
          top: "52%",
          width: "15%",
          height: "33%",
          border: "1px dashed",
          borderColor: "grey.400",
          bgcolor: "grey.100",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Typography variant="caption">D2</Typography>
      </Box>
    </Box>
  );
}

export default Plantilla1Preview;
